// extracted by mini-css-extract-plugin
export default {"choice":"choice_choice__d8oQR","choice__input":"choice_choice__input__lWikB","choice__body":"choice_choice__body__fpOLJ","choice__outline":"choice_choice__outline__t-Om1"};